/**
 * Created by elmer on 13/07/17.
 */

export function getTipo(url) {
  const parts = url.split('.');
  const ext = parts[parts.length - 1].toLowerCase();
  if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(ext) > -1) {
    return 'Foto';
  }
  if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(ext) > -1) {
    return 'Video';
  }
  if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(ext) > -1) {
    return 'Audio';
  }
  return null;
}

export function getParsedFile(data) {
  return {
    ...data,
    archivo: data.archivo ? `${process.env.API_URL}/${data.archivo}` : null,
    tipo_archivo: data.tipo_archivo || getTipo(data.archivo),
    fecha_inicio: data.fecha_inicio === '0000-00-00' ? null : data.fecha_inicio,
    fecha_fin: data.fecha_fin === '0000-00-00' ? null : data.fecha_fin,
  };
}



// WEBPACK FOOTER //
// ./src/modules/admin/publicidad.utils.js